// TODO: this is a temporary solution to prevent too many events from being pushed
// these events are triggered multiple times because of useAppConfigStore hook
// which is used in multiple components. We should consider zustand.

const EVENT_THROTTLE_MS = 300; // Minimum time between same event types

// Events that should NOT be throttled (intentional user actions that may fire rapidly)
const NON_THROTTLED_EVENTS = ["userInteraction"] as const;

const createEventThrottle = () => {
  let lastEventTimestamps: Record<string, number> = {};

  const shouldThrottleEvent = (eventType: string): boolean => {
    // Don't throttle user interaction events - these are intentional and may fire
    // multiple times when committing batched filter changes
    if (NON_THROTTLED_EVENTS.includes(eventType as (typeof NON_THROTTLED_EVENTS)[number])) {
      return false;
    }

    const now = Date.now();
    const lastTimestamp = lastEventTimestamps[eventType] || 0;
    if (now - lastTimestamp < EVENT_THROTTLE_MS) {
      return true;
    }
    lastEventTimestamps[eventType] = now;
    return false;
  };

  const reset = () => {
    lastEventTimestamps = {};
  };

  return {
    shouldThrottleEvent,
    reset,
  };
};

export const eventThrottle = createEventThrottle();
